module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    attrs: {
      "title": _vm.title,
      "url": '/candidates' + (this.siteId ? '/site/' + this.siteId : '') + (this.clientId ? '/client/' + this.clientId : ''),
      "table-ref": _vm.tableRef,
      "fields": _vm.fields,
      "options": _vm.options,
      "show-search": false,
      "sort-field": "site_id,client_id,optionNo|desc",
      "show-refresh": "",
      "add-action": _vm.action,
      "add-props": _vm.addProps,
      "search-placeholder": _vm.searchPlaceholder,
      "detail-component": "acquire-detail-row"
    },
    on: {
      "totalChanged": _vm.totalOptions
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.addSuffix(props.rowData.optionNo))
          }
        }), _vm._v("\n           " + _vm._s(props.rowData.title ? props.rowData.title + (props.rowData.clientRef ? ' | Ref:' + props.rowData.clientRef : '') : props.rowData.clientRef)), _vm._v(" "), (props.rowData.surveyDate) ? _c('span', [_vm._v(" Survey Date: " + _vm._s(_vm.formatDate(props.rowData.surveyDate)))]) : _vm._e(), _vm._v(" "), (props.rowData.landType) ? _c('span', [_vm._v(" | Land Type: "), _c('b', [_vm._v(_vm._s(props.rowData.landType))])]) : _vm._e(), _vm._v(" "), (props.rowData.classificationType) ? _c('span', [_vm._v(" | Classification Type: "), _c('b', [_vm._v(_vm._s(props.rowData.classificationType))])]) : _vm._e()]
      }
    }, {
      key: "details",
      fn: function(props) {
        return [(props.rowData.structure) ? _c('span', {
          attrs: {
            "label": "Structure Type"
          }
        }, [_c('i', {
          staticClass: "fa fa-broadcast-tower"
        }, [_vm._v(" ")]), _vm._v(_vm._s(props.rowData.structure.name) + " "), (props.rowData.structureHeight) ? _c('b', [_vm._v(_vm._s(props.rowData.structureHeight) + "m.")]) : _vm._e(), _vm._v(" ")]) : _vm._e(), _vm._v(" "), (props.rowData.antennaHeight) ? _c('span', [_vm._v("Ant. "), _c('i', {
          staticClass: "fa fa-arrows-alt-v"
        }), _vm._v(" "), _c('b', [_vm._v(_vm._s(props.rowData.antennaHeight) + "m")])]) : _vm._e()]
      }
    }, {
      key: "distance",
      fn: function(props) {
        return [(props.rowData.distanceFromNominal) ? _c('el-tooltip', {
          attrs: {
            "content": "Distance from Nominal",
            "placement": "left"
          }
        }, [_c('span', [_c('i', {
          staticClass: "fa fa-bullseye"
        }), _vm._v(" "), _c('b', [_vm._v(_vm._s(props.rowData.distanceFromNominal) + "m")])])]) : _vm._e(), _vm._v(" "), (props.rowData.distanceAccessRoad) ? _c('el-tooltip', {
          attrs: {
            "content": "Distance to Access Road",
            "placement": "top"
          }
        }, [_c('span', [_vm._v(" | "), _c('i', {
          staticClass: "fa fa-road"
        }), _vm._v(" "), _c('b', [_vm._v(_vm._s(props.rowData.distanceAccessRoad) + "m")])])]) : _vm._e(), _vm._v(" "), (props.rowData.distanceNearestBuilding) ? _c('el-tooltip', {
          attrs: {
            "content": "Distance to Nearest Building"
          }
        }, [_c('span', [_vm._v(" | "), _c('i', {
          staticClass: "fa fa-home"
        }), _vm._v(" "), _c('b', [_vm._v(_vm._s(props.rowData.distanceNearestBuilding) + "m")])])]) : _vm._e(), _vm._v(" "), (props.rowData.distanceNearestPower) ? _c('el-tooltip', {
          attrs: {
            "content": "Distance to Nearest Commerical Power",
            "placement": "right"
          }
        }, [_c('span', [_vm._v(" | "), _c('i', {
          staticClass: "fa fa-plug"
        }), _vm._v(" "), _c('b', [_vm._v(_vm._s(props.rowData.distanceNearestPower) + "m")])])]) : _vm._e()]
      }
    }, {
      key: "delete",
      fn: function(props) {
        return [(_vm.isTelco() || _vm.isManager('project|property|finance|admin|management')) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "circle": "",
            "icon": "fa fa-trash",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.deleteOption(props.rowData)
            }
          }
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('center', {
    staticClass: "text-muted"
  }, [_vm._v("Total: " + _vm._s(_vm.currentNo))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46d947a3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/SiteCandidates.vue
// module id = 1538
// module chunks = 0